import { useEffect, useState } from 'react'

export const useScrollSpy = (ids: string[], offset = 96): { activeId: string | null } => {
  const [activeId, setActiveId] = useState<string | null>(null)

  useEffect(() => {
    if (!ids.length) return

    const calc = (): void => {
      const y = window.scrollY + offset + 1
      let best: string | null = null
      let dist = Infinity

      for (const id of ids) {
        const el = document.getElementById(id)
        if (!el) continue
        const top = el.getBoundingClientRect().top + window.scrollY
        const d = Math.abs(top - y)
        if (d < dist) { dist = d; best = id }
      }

      if (best && best !== activeId) setActiveId(best)
    }

    const onScroll = (): void => { requestAnimationFrame(calc) }

    calc()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
    }
  }, [ids.join('|'), offset, activeId])

  return { activeId }
}
